import React from "react";
import "./Home.css";
import heroImg from "./hero-img.png";
import hassanImg from "./hassan.jpg";
import graphic from "./graphic.png";
import codingImg from "./codingImg.png";
import webDesign from "./webDesign.png";
import Sites from "./Sites";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import SiteDetails from "./SiteDetails";
import Footer from "./Footer";

function Home() {
  return (
    <div className="home">
      <div className="hero" id="hero">
        <div className="hero__left">
          <h1>Let The World Discover Your Website</h1>
          <p>
            We aim to facilitate your GROWTH by promoting your website and
            attracting more visitors through sharing.
          </p>
          <div className="explore__contact">
            <Link to="/sites">
              <button>Explore Now</button>
            </Link>

            <a href="https://wa.me/212690978812" target="_blank">Contact Us</a>
          </div>
        </div>
        <div className="hero__right">
          <img src={heroImg} alt="" />
        </div>
      </div>

      <div className="responsive-container-block container" id="team">
        <p className="text-blk team-head-text" style={{ color: "#37517e" }}>
          Team
        </p>
        <div className="responsive-container-block">
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img
                  className="team-member-image"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/ET7.15.png"
                />
              </div>
              <p className="text-blk name">Davis Isabelle</p>
              <p className="text-blk position">CEO</p>
              <p className="text-blk feature-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img className="team-member-image" src={hassanImg} />
              </div>
              <p className="text-blk name">Hassan ElAmri</p>
              <p className="text-blk position">Their Husband</p>
              <p className="text-blk feature-text">
                i've the power of 6 horses 🔥🔥🔥
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img
                  className="team-member-image"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/expert1.png"
                />
              </div>
              <p className="text-blk name">Ellie May</p>
              <p className="text-blk position">CEO</p>
              <p className="text-blk feature-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* services */}
      <section className="services" id="services">
        <div className="row">
          {/* <h2 className="section-heading">Our Services</h2> */}
          <p className="text-blk team-head-text" style={{ color: "#37517e" }}>
            Services
          </p>
        </div>
        <div className="row">
          <div className="column">
            <div className="card">
              <img src={codingImg} alt="" className="services__icon" />
              <h3>Web Development</h3>
              <p>
                Crafting captivating websites with clean, modern design. Let's
                make your online vision a reality.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={graphic} alt="" className="services__icon" />

              <h3>Graphic Design</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={webDesign} alt="" className="services__icon" />
              <h3>Web Design</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <img src={codingImg} alt="" className="services__icon" />
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <div className="icon-wrapper">
                <i className="fas fa-broom"></i>
              </div>
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <div className="icon-wrapper">
                <i className="fas fa-plug"></i>
              </div>
              <h3>Service Heading</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Quisquam consequatur necessitatibus eaque.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* faq */}

      <div className="faq" id="faq" style={{ background: "#37517e" }}>
        <p className="faq__title">Faq</p>

        <details class="accordion">
          <summary class="accordion-btn">
            {" "}
            Why should I share my website online?
          </summary>
          <div class="accordion-content">
            <p>
              Sharing your website online increases its visibility, making it
              accessible to a wider audience. It can attract potential
              customers, increase brand awareness, and generate leads.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            What are the benefits of sharing my website on forums and
            communities?
          </summary>
          <div class="accordion-content">
            <p>
              Sharing on forums and communities can establish credibility, build
              relationships with potential customers, and drive targeted traffic
              to your website if you engage meaningfully and provide valuable
              content.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            How can I track the impact of sharing my website online?
          </summary>
          <div class="accordion-content">
            <p>
              Utilizing web analytics tools like Google Analytics can help track
              website traffic, user behavior, referral sources, and conversion
              rates. This data can provide insights into the effectiveness of
              your sharing strategies.
            </p>
          </div>
        </details>

        <details class="accordion">
          <summary class="accordion-btn">
            Can I optimize my website for better sharing?
          </summary>
          <div class="accordion-content">
            <p>
              Yes, you can optimize your website by adding social sharing
              buttons, creating shareable content, optimizing meta tags for
              social media, and ensuring your site is mobile-friendly to enhance
              the sharing experience.
            </p>
          </div>
        </details>
      </div>

      {/* footer */}

      <Footer />
    </div>
  );
}

export default Home;
